import React from 'react'

type LogoProps = {
  className?: string
}

const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <img
      className={className}
      src="https://app.effectivealtruism.org/logo-funds.svg"
    />
  )
}

export default Logo
